const en = {
  b7: {
    menu: "Menu", close_menu: "Close menu", learn: "Learn", explore: "Explore", apps: "Mobile apps",
    soon: "Coming soon", apps_note: "The Valeriia apps for iPhone and Android are in preparation.",
    apple_alt: "Download on the App Store", google_alt: "Get it on Google Play",
  },
};

const ru = {
  b7: {
    menu: "Меню", close_menu: "Закрыть меню", learn: "Обучение", explore: "Платформа", apps: "Мобильные приложения",
    soon: "Скоро", apps_note: "Приложения Valeriia для iPhone и Android готовятся к выпуску.",
    apple_alt: "Загрузите в App Store", google_alt: "Скачать из Google Play",
  },
};

export default { en, ru };
